<template>
    <div>
        <div class="images" v-if="imageUrl">
            <div class="img-box">
                <img class="rotate_image" :src="getImageUrl(imageUrl)" />
                <div class="img-mask">
                    <i class="el-icon-delete" @click="deleteImg(imageUrl)"></i>
                    <i class="el-icon-zoom-in" @click="previewImg(imageUrl)"></i>
                </div>
            </div>
        </div>
        <div class="images" v-else>
            <div class="img-box felx_">
                <input class="upload-img" type="file" accept=".png,.jpg,.jpeg" @change="updateImg($event)" />
                <i class="el-icon-plus" style="font-size:50px;"></i>
            </div>
        </div>
        <div class="felx_">
            <el-button size="small" plain @click="hideQR">关闭</el-button>
        </div>
        
    </div>
</template>

<script>
    import config from "@/common/env.js";

    export default {
        props: ["roomId", "QRimageUrl"],
        data () {
            return {
                imageUrl: null,
            }
        },
        computed: {
            
        },
        created () {
            this.imageUrl = this.QRimageUrl;
        },
        mounted () {
            
        },
        methods: {
            updateImg(e) {
                let file = e.target.files[0];
                let params = new FormData();
                params.append("file", file);
                params.append("recordId", this.roomId);
                    
                this.$axios.post(`/admin/appointment/upload/payqr`, params).then(res => {
                    let datas = this.AppUtils.checkResponse(res);
                    console.log(datas)
					let { code, data, msg } = datas;
                    if(code == 0) {
                        this.imageUrl = `${data.url}`;
                    } else {
                        this.$message.error(msg)
                    }
                    this.resetFile(e);
                })
            },
            getImageUrl(url, type) {
				let str = "/file/server/decrypt/file";
				return `${config.baseUrl}${str}?path=${encodeURI(url)}`;
			},

            deleteImg() {
				this.imageUrl = null;
			},

            previewImg(url) {
                let _this = this;
                if (this.$store.state.previewImgUrl) {
                    this.$store.commit("SHOW_PREVIEW_IMG", '')
                }
				setTimeout(() => {
                    localStorage.setItem("myPics", JSON.stringify([url]));
					_this.$store.commit("SHOW_PREVIEW_IMG", url);
				}, 500)
			},

            hideQR() {
                this.$emit("hideQR");
            },

            resetFile (e) { //清空file
                e.target.type = "text";
                e.target.value = " ";
                e.target.type = "file";
                e.target.name = "file";
            },

        }
    }
</script>

<style scoped lang="scss">
    .images {
        // width: 200px;
        height: 200px;
        margin: 10px 10px 30px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;

        .img-box {
            width: 200px;
            margin: 0 auto;
        }
    }
    .felx_ {
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>


// WEBPACK FOOTER //
// image.vue?6e1b095f